// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1t4Wk","inputWrap":"Table_inputWrap__1Q-jv","col":"Table_col__2EU6G","bmiTooltip":"Table_bmiTooltip__27_go"};